
<div>
    <div v-if="showRichTable" class="row action-bar">
        <div class="col col-8">
            <b-input-group v-if="enableSearch" class="filter-input">
                <template #prepend
                    ><b-input-group-text
                        ><b-icon-search /></b-input-group-text
                ></template>
                <b-input
                    v-model="filter"
                    :debounce="debounce"
                    :placeholder="
                        $t('overview.suppliers.table.search.placeholder')
                    "
                />
            </b-input-group>
        </div>

        <div
            v-if="enableSort && sortOptions && sortOptions.length"
            class="col col-4 text-right"
        >
            <b-dropdown
                no-caret
                right
                size="md"
                toggle-tag="div"
                class="ordering"
                @show="orderingExpanded = true"
                @hide="orderingExpanded = false"
            >
                <template v-slot:button-content>
                    <small>
                        <span class="text-muted"
                            >{{ $t("ordering.label") }}:</span
                        >
                        {{ selectedSortOption.text }}
                    </small>
                    <AnimatedCaret :expanded="orderingExpanded" />
                </template>

                <b-dropdown-item
                    v-for="(n, i) in sortOptions"
                    :key="'opt-sort-' + i"
                    :active="selectedSortOptionValue == i"
                    @click="selectedSortOptionValue = i"
                >
                    {{ n.text }}
                </b-dropdown-item>
            </b-dropdown>
        </div>
    </div>
    <DataTable
        v-bind="settings"
        ref="data_table"
        :sort-by.sync="selectedSortOption.value.by"
        :sort-desc.sync="selectedSortOption.value.desc"
        :enable-pagination="enablePagination"
        :enable-total-rows="enableTotalRows"
        :show-rich-table="showRichTable"
        v-on="$listeners"
    >
        <slot v-for="(_, name) in $slots" :name="name" :slot="name" />
        <template
            v-for="(_, name) in $scopedSlots"
            :slot="name"
            slot-scope="slotData"
            ><slot :name="name" v-bind="slotData"
        /></template>
    </DataTable>
</div>
